var map = {
	"./pc/pcbg1.jpg": 7351,
	"./pc/pcbg2.jpg": 2231,
	"./pc/pcbg3.jpg": 482,
	"./pc/pcbg4.jpg": 2031,
	"./pc/pcbg5.jpg": 9177,
	"./pcBlack/pcbg1.jpg": 54,
	"./pcBlack/pcbg2.jpg": 1193,
	"./pcBlack/pcbg3.jpg": 9192,
	"./pcBlack/pcbg4.jpg": 1878,
	"./pcBlack/pcbg5.jpg": 6768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7050;